import { c as _c } from "react/compiler-runtime";
import { COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS } from "@src/constants/subscription-constants";
import { fetchCompanySubscriptions } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";

/**
 * Fetches the subscriptions of the selected workspace into the store.
 *
 * The workspace loader only fetches them for users that may view subscription details, so a page
 * that derives anything from them cannot rely on them already being there and has to ask for them
 * itself. Users that may not read them get a rejected request that leaves the subscriptions empty,
 * which is the same state as a workspace without any subscription.
 */
export function useFetchCompanySubscriptions() {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch(fetchCompanySubscriptions({
        queryOptions: COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS
      }));
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}